// Mock Data for Just Travel Landing Page
import { additionalCountries, blogPosts as importedBlogPosts } from './additionalCountries';

export const countries = [
  {
    id: 'germany',
    name: 'Deutschland',
    continent: 'Europa',
    image: 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=800',
    optimalAirports: [
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 300, avgPrice: '€250', parking: 'Holiday Extras - €45/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 250, avgPrice: '€280', parking: 'Airparks - €42/Woche' },
      { name: 'Berlin (BER)', city: 'Berlin', directFlights: 180, avgPrice: '€220', parking: 'ParkVia - €38/Woche' }
    ],
    scores: {
      friendliness: 8.2,
      easyTravel: 9.5,
      womenSafety: 9.3,
      sustainability: 8.7
    },
    valueScore: {
      internetSpeed: '85 Mbps',
      livingCosts: '€1,200/Monat',
      rent: '€800/Monat',
      nomadScore: 7.8
    },
    optimalTravelTime: {
      best: 'Mai - September',
      reason: 'Angenehmes Wetter, lange Tage, Biergarten-Saison. Vermeide Schulferien (Juli-Aug).'
    },
    weather: [
      { month: 'Jan', temp: '2°C', rain: '45mm' },
      { month: 'Feb', temp: '3°C', rain: '40mm' },
      { month: 'Mär', temp: '7°C', rain: '42mm' },
      { month: 'Apr', temp: '12°C', rain: '38mm' },
      { month: 'Mai', temp: '17°C', rain: '55mm' },
      { month: 'Jun', temp: '20°C', rain: '70mm' },
      { month: 'Jul', temp: '22°C', rain: '75mm' },
      { month: 'Aug', temp: '22°C', rain: '68mm' },
      { month: 'Sep', temp: '18°C', rain: '50mm' },
      { month: 'Okt', temp: '13°C', rain: '45mm' },
      { month: 'Nov', temp: '7°C', rain: '50mm' },
      { month: 'Dez', temp: '3°C', rain: '48mm' }
    ],
    transportation: [
      { type: 'Bahn (DB)', cost: '€50-150', speed: 'Schnell', comfort: 'Hoch' },
      { type: 'FlixBus', cost: '€15-40', speed: 'Mittel', comfort: 'Mittel' },
      { type: 'Mietwagen', cost: '€35-80/Tag', speed: 'Flexibel', comfort: 'Hoch' }
    ],
    noGos: [
      'Nazi-Symbolik oder -Gesten (illegal)',
      'Sonntags einkaufen (meiste Geschäfte geschlossen)',
      'Unpünktlichkeit bei geschäftlichen Terminen'
    ],
    avgCosts: {
      coffee: '€3.20',
      beer: '€4.00',
      wine: '€5.50',
      water: '€2.50',
      localFood: '€12-18',
      massage: '€65',
      manicure: '€35',
      botox: '€280-350',
      teethWhitening: '€350-500'
    },
    apps: [
      { name: 'DB Navigator', purpose: 'Bahn & ÖPNV', affiliate: 'https://www.bahn.de/service/mobile/db-navigator' },
      { name: 'Flixbus', purpose: 'Fernbus-Tickets', affiliate: 'https://www.flixbus.de/service/mobil/flixbus-app' },
      { name: 'PayPal', purpose: 'Bezahlen', affiliate: 'https://www.paypal.com/de/webapps/mpp/mobile-apps' }
    ],
    travelGuides: [
      { title: 'Lonely Planet Deutschland', link: 'https://www.amazon.de/s?k=Lonely+Planet+Deutschland', price: '€22.99' },
      { title: 'Baedeker Deutschland', link: 'https://www.amazon.de/s?k=Baedeker+Deutschland', price: '€24.95' }
    ],
    travel_tips: {
      highlights: ["Berlin", "München", "Hamburg", "Sächsische Schweiz", "Schwarzwald", "Romantische Straße"],
      hidden_gems: ["Basteibrücke (Sachsen)", "Saalfelder Feengrotten (Thüringen)", "Rakotzbrücke (Sachsen-Anhalt)", "Kostenlose Wanderwege an Rhein & Donau"],
      mobility_tips: [
        "DB-Sparbuchungen & Quer-durchs-Land-Ticket nutzen",
        "FlixBus/BlaBlaBus günstiger als Taxi",
        "Park-&-Ride an Bahnhöfen statt Flughafenparkplätze",
        "ÖPNV mit Tages-/Gruppentickets nutzen"
      ],
      eating_tips: [
        "Lidl, Aldi, Netto für günstige Basics",
        "Frühstück selbst machen spart deutlich",
        "Stadtrand-Lokale billiger als Zentrum"
      ],
      too_good_to_go: "In Deutschland extrem verbreitet: über 900 Städte. 'Surprise Bags' für 3-5 € mit Pasta, Brot, Snacks, Kuchen.",
      entry_requirements: ["Personalausweis oder Reisepass", "Kein Visum für EU-Bürger"],
      international_license_needed: false,
      medication_tips: [
        "Grundmedikamente in Apotheken erhältlich, aber teurer",
        "Mückenschutz & Sonnencreme: günstige Drogerie-Marken (DM, Rossmann) reichen"
      ],
      birthday_freebies: [
        "Berlin: Gratis bei Schwimmbädern, Zoos, Thermen, Museen",
        "München: Freizeitpark, Zoo, Filmstudio gratis an Geburtstag",
        "Personalausweis vorzeigen, oft Vor-Anmeldung nötig"
      ]
    }
  },
  {
    id: 'austria',
    name: 'Österreich',
    continent: 'Europa',
    image: 'https://images.unsplash.com/photo-1673286900865-ab88ead9285b?w=800',
    optimalAirports: [
      { name: 'Wien (VIE)', city: 'Wien', directFlights: 180, avgPrice: '€200', parking: 'Parkos - €48/Woche' },
      { name: 'Innsbruck (INN)', city: 'Innsbruck', directFlights: 45, avgPrice: '€180', parking: 'Holiday Extras - €55/Woche' }
    ],
    scores: {
      friendliness: 8.5,
      easyTravel: 9.2,
      womenSafety: 9.5,
      sustainability: 8.9
    },
    valueScore: {
      internetSpeed: '78 Mbps',
      livingCosts: '€1,100/Monat',
      rent: '€750/Monat',
      nomadScore: 7.5
    },
    optimalTravelTime: {
      best: 'Mai-September (Sommer), Dezember-März (Ski)',
      reason: 'Sommerwandern in den Alpen oder Wintersport. Vermeide Osterferien.'
    },
    weather: [
      { month: 'Jan', temp: '-2°C', rain: '38mm' },
      { month: 'Feb', temp: '0°C', rain: '35mm' },
      { month: 'Mär', temp: '5°C', rain: '40mm' },
      { month: 'Apr', temp: '10°C', rain: '45mm' },
      { month: 'Mai', temp: '15°C', rain: '65mm' },
      { month: 'Jun', temp: '18°C', rain: '75mm' },
      { month: 'Jul', temp: '20°C', rain: '80mm' },
      { month: 'Aug', temp: '20°C', rain: '75mm' },
      { month: 'Sep', temp: '16°C', rain: '55mm' },
      { month: 'Okt', temp: '11°C', rain: '42mm' },
      { month: 'Nov', temp: '5°C', rain: '48mm' },
      { month: 'Dez', temp: '0°C', rain: '42mm' }
    ],
    transportation: [
      { type: 'ÖBB (Bahn)', cost: '€40-120', speed: 'Schnell', comfort: 'Hoch' },
      { type: 'FlixBus', cost: '€12-35', speed: 'Mittel', comfort: 'Mittel' },
      { type: 'Mietwagen', cost: '€40-90/Tag', speed: 'Flexibel', comfort: 'Hoch' }
    ],
    noGos: [
      'Österreich als "Teil von Deutschland" bezeichnen',
      'Sonntags in Geschäften einkaufen',
      'In Bergregionen Wanderwege verlassen'
    ],
    avgCosts: {
      coffee: '€3.80',
      beer: '€4.50',
      wine: '€6.00',
      water: '€2.80',
      localFood: '€14-20',
      massage: '€70',
      manicure: '€40',
      botox: '€300-380',
      teethWhitening: '€380-550'
    },
    apps: [
      { name: 'ÖBB Scotty', purpose: 'Bahn & ÖPNV', affiliate: '#' },
      { name: 'Bergfex', purpose: 'Wandern & Ski', affiliate: '#' }
    ],
    travelGuides: [
      { title: 'DuMont Reise Österreich', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€24.99' }
    ]
  },
  {
    id: 'thailand',
    name: 'Thailand',
    continent: 'Asien',
    image: 'https://images.unsplash.com/photo-1571555788467-71d9e3add426',
    optimalAirports: [
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 25, avgPrice: '€550', parking: 'Holiday Extras - €45/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 18, avgPrice: '€580', parking: 'Airparks - €42/Woche' },
      { name: 'Zürich (ZRH)', city: 'Zürich', directFlights: 20, avgPrice: '€620', parking: 'Parkos - €65/Woche' }
    ],
    scores: {
      friendliness: 9.2,
      easyTravel: 8.8,
      womenSafety: 7.8,
      sustainability: 6.5
    },
    valueScore: {
      internetSpeed: '120 Mbps',
      livingCosts: '€650/Monat',
      rent: '€350/Monat',
      nomadScore: 9.2
    },
    optimalTravelTime: {
      best: 'November - Februar',
      reason: 'Trockenzeit, angenehme Temperaturen (25-30°C). Vermeide April (Hitze) und September (Monsun).'
    },
    weather: [
      { month: 'Jan', temp: '27°C', rain: '15mm' },
      { month: 'Feb', temp: '28°C', rain: '20mm' },
      { month: 'Mär', temp: '30°C', rain: '35mm' },
      { month: 'Apr', temp: '31°C', rain: '65mm' },
      { month: 'Mai', temp: '30°C', rain: '180mm' },
      { month: 'Jun', temp: '29°C', rain: '150mm' },
      { month: 'Jul', temp: '29°C', rain: '155mm' },
      { month: 'Aug', temp: '29°C', rain: '160mm' },
      { month: 'Sep', temp: '28°C', rain: '300mm' },
      { month: 'Okt', temp: '28°C', rain: '240mm' },
      { month: 'Nov', temp: '27°C', rain: '50mm' },
      { month: 'Dez', temp: '26°C', rain: '10mm' }
    ],
    transportation: [
      { type: 'Grab (Taxi-App)', cost: '€2-8', speed: 'Schnell', comfort: 'Mittel' },
      { type: 'Songthaew (Sammeltaxi)', cost: '€0.50-1', speed: 'Langsam', comfort: 'Niedrig' },
      { type: 'Roller-Miete', cost: '€5-8/Tag', speed: 'Flexibel', comfort: 'Mittel' },
      { type: 'Inlandsflüge', cost: '€30-80', speed: 'Sehr schnell', comfort: 'Hoch' }
    ],
    noGos: [
      'Buddha-Statuen oder Tempel respektlos behandeln',
      'Kopf berühren (heilig)',
      'Mit Füßen auf Personen/Buddha zeigen',
      'Oben-ohne am Strand (Frauen)',
      'Kritik am Königshaus (illegal!)',
      'Kleidung: Schultern & Knie bedecken in Tempeln'
    ],
    avgCosts: {
      coffee: '€1.50',
      beer: '€1.80',
      wine: '€8.00',
      water: '€0.30',
      localFood: '€1.50-3.00',
      massage: '€8',
      manicure: '€6',
      botox: '€120-180',
      teethWhitening: '€150-250'
    },
    apps: [
      { name: 'Grab', purpose: 'Transport & Food', affiliate: 'https://www.grab.com' },
      { name: 'Wise', purpose: 'Geld überweisen', affiliate: 'https://wise.com' },
      { name: 'Google Translate', purpose: 'Übersetzung', affiliate: 'https://translate.google.com' }
    ],
    travelGuides: [
      { title: 'Lonely Planet Thailand', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€21.99' },
      { title: 'Stefan Loose Thailand', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€26.99' }
    ],
    travel_tips: {
      highlights: ['Bangkok', 'Chiang Mai', 'Phuket', 'Koh Samui', 'Krabi'],
      hidden_gems: ['Nan-Provinz', 'Mae Hong Son', 'Isaan-Region'],
      mobility_tips: ['Bus, Mini-Bus günstig', 'Low-Cost-Flüge'],
      eating_tips: ['Essen extrem günstig', 'Street-Food perfekt'],
      too_good_to_go: "Nicht aktiv.",
      entry_requirements: ['Reisepass', '30-90 Tage meist ohne Visum'],
      international_license_needed: false,
      medication_tips: ['Mückenschutz wichtig', 'Sonnencreme vorher mitnehmen'],
      birthday_freebies: ['Bangkok: Hotels bieten Gratis-Eintritte']
    }
  },
  {
    id: 'philippines',
    name: 'Philippinen',
    continent: 'Asien',
    image: 'https://images.unsplash.com/photo-1566204992830-4f38a29c2600',
    optimalAirports: [
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 8, avgPrice: '€650', parking: 'Holiday Extras - €45/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 5, avgPrice: '€680', parking: 'Airparks - €42/Woche' }
    ],
    scores: {
      friendliness: 9.5,
      easyTravel: 7.5,
      womenSafety: 7.2,
      sustainability: 6.0
    },
    valueScore: {
      internetSpeed: '45 Mbps',
      livingCosts: '€550/Monat',
      rent: '€280/Monat',
      nomadScore: 8.5
    },
    optimalTravelTime: {
      best: 'Dezember - Mai',
      reason: 'Trockenzeit, ideal für Insel-Hopping. Vermeide Juni-November (Taifun-Saison).'
    },
    weather: [
      { month: 'Jan', temp: '26°C', rain: '25mm' },
      { month: 'Feb', temp: '27°C', rain: '15mm' },
      { month: 'Mär', temp: '28°C', rain: '20mm' },
      { month: 'Apr', temp: '29°C', rain: '30mm' },
      { month: 'Mai', temp: '29°C', rain: '120mm' },
      { month: 'Jun', temp: '28°C', rain: '250mm' },
      { month: 'Jul', temp: '28°C', rain: '320mm' },
      { month: 'Aug', temp: '27°C', rain: '360mm' },
      { month: 'Sep', temp: '27°C', rain: '305mm' },
      { month: 'Okt', temp: '27°C', rain: '240mm' },
      { month: 'Nov', temp: '27°C', rain: '140mm' },
      { month: 'Dez', temp: '26°C', rain: '60mm' }
    ],
    transportation: [
      { type: 'Jeepney', cost: '€0.20-0.50', speed: 'Langsam', comfort: 'Niedrig' },
      { type: 'Tricycle', cost: '€0.50-2', speed: 'Mittel', comfort: 'Niedrig' },
      { type: 'Grab', cost: '€2-6', speed: 'Schnell', comfort: 'Mittel' },
      { type: 'Fähren', cost: '€15-40', speed: 'Langsam', comfort: 'Mittel' },
      { type: 'Inlandsflüge', cost: '€25-70', speed: 'Schnell', comfort: 'Hoch' }
    ],
    noGos: [
      'Drogen (Todesstrafe möglich!)',
      'Politische Diskussionen',
      'Finger-Zeigen auf Personen (unhöflich)',
      'Laut sein in der Öffentlichkeit'
    ],
    avgCosts: {
      coffee: '€1.20',
      beer: '€1.00',
      wine: '€6.50',
      water: '€0.25',
      localFood: '€1.00-2.50',
      massage: '€6',
      manicure: '€4',
      botox: '€100-150',
      teethWhitening: '€120-200'
    },
    apps: [
      { name: 'Grab', purpose: 'Transport', affiliate: '#' },
      { name: 'Cebu Pacific', purpose: 'Inlandsflüge', affiliate: '#' },
      { name: 'GCash', purpose: 'Mobile Payment', affiliate: '#' }
    ],
    travelGuides: [
      { title: 'Lonely Planet Philippines', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€22.99' }
    ]
  },
  {
    id: 'newyork',
    name: 'New York',
    continent: 'Amerika',
    image: 'https://images.unsplash.com/photo-1605130284535-11dd9eedc58a',
    optimalAirports: [
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 45, avgPrice: '€450', parking: 'Holiday Extras - €45/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 28, avgPrice: '€480', parking: 'Airparks - €42/Woche' },
      { name: 'Zürich (ZRH)', city: 'Zürich', directFlights: 35, avgPrice: '€520', parking: 'Parkos - €65/Woche' }
    ],
    scores: {
      friendliness: 7.5,
      easyTravel: 8.5,
      womenSafety: 7.8,
      sustainability: 7.2
    },
    valueScore: {
      internetSpeed: '180 Mbps',
      livingCosts: '€3,200/Monat',
      rent: '€2,500/Monat',
      nomadScore: 6.0
    },
    optimalTravelTime: {
      best: 'April-Juni & September-November',
      reason: 'Mildes Wetter, weniger Touristen. Vermeide Juli-August (heiß & voll) und Dezember-Februar (kalt).'
    },
    weather: [
      { month: 'Jan', temp: '0°C', rain: '92mm' },
      { month: 'Feb', temp: '2°C', rain: '78mm' },
      { month: 'Mär', temp: '7°C', rain: '110mm' },
      { month: 'Apr', temp: '13°C', rain: '114mm' },
      { month: 'Mai', temp: '19°C', rain: '106mm' },
      { month: 'Jun', temp: '24°C', rain: '112mm' },
      { month: 'Jul', temp: '27°C', rain: '116mm' },
      { month: 'Aug', temp: '26°C', rain: '113mm' },
      { month: 'Sep', temp: '22°C', rain: '108mm' },
      { month: 'Okt', temp: '16°C', rain: '112mm' },
      { month: 'Nov', temp: '10°C', rain: '102mm' },
      { month: 'Dez', temp: '4°C', rain: '101mm' }
    ],
    transportation: [
      { type: 'U-Bahn (Subway)', cost: '€2.90/Fahrt', speed: 'Schnell', comfort: 'Mittel' },
      { type: 'Bus', cost: '€2.90/Fahrt', speed: 'Langsam', comfort: 'Mittel' },
      { type: 'Taxi/Uber', cost: '€15-40', speed: 'Mittel', comfort: 'Hoch' },
      { type: 'Citi Bike', cost: '€3.50/30min', speed: 'Mittel', comfort: 'Niedrig' }
    ],
    noGos: [
      'Rechts auf Rolltreppen stehen bleiben',
      'Mitten auf dem Gehweg stehen bleiben',
      'Kein Trinkgeld geben (15-20% Standard)',
      'Alkohol auf der Straße trinken (illegal)'
    ],
    avgCosts: {
      coffee: '€5.50',
      beer: '€8.00',
      wine: '€12.00',
      water: '€2.00',
      localFood: '€15-25',
      massage: '€120',
      manicure: '€35',
      botox: '€400-600',
      teethWhitening: '€500-800'
    },
    apps: [
      { name: 'MTA (Subway)', purpose: 'ÖPNV', affiliate: '#' },
      { name: 'Uber', purpose: 'Transport', affiliate: '#' },
      { name: 'Yelp', purpose: 'Restaurants', affiliate: '#' }
    ],
    travelGuides: [
      { title: 'Lonely Planet New York', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€19.99' }
    ]
  },
  {
    id: 'croatia',
    name: 'Kroatien',
    continent: 'Europa',
    image: 'https://images.unsplash.com/photo-1414862625453-d87604a607e4?w=800',
    optimalAirports: [
      { name: 'München (MUC)', city: 'München', directFlights: 55, avgPrice: '€120', parking: 'Airparks - €42/Woche' },
      { name: 'Wien (VIE)', city: 'Wien', directFlights: 48, avgPrice: '€90', parking: 'Parkos - €48/Woche' },
      { name: 'Zürich (ZRH)', city: 'Zürich', directFlights: 42, avgPrice: '€150', parking: 'Parkos - €65/Woche' }
    ],
    scores: {
      friendliness: 8.8,
      easyTravel: 8.9,
      womenSafety: 8.9,
      sustainability: 7.8
    },
    valueScore: {
      internetSpeed: '65 Mbps',
      livingCosts: '€800/Monat',
      rent: '€500/Monat',
      nomadScore: 8.2
    },
    optimalTravelTime: {
      best: 'Mai-Juni & September',
      reason: 'Warmes Wetter, weniger Touristen, günstigere Preise. Vermeide Juli-August (überfüllt & teuer).'
    },
    weather: [
      { month: 'Jan', temp: '7°C', rain: '65mm' },
      { month: 'Feb', temp: '8°C', rain: '60mm' },
      { month: 'Mär', temp: '11°C', rain: '58mm' },
      { month: 'Apr', temp: '15°C', rain: '60mm' },
      { month: 'Mai', temp: '20°C', rain: '55mm' },
      { month: 'Jun', temp: '24°C', rain: '50mm' },
      { month: 'Jul', temp: '27°C', rain: '35mm' },
      { month: 'Aug', temp: '27°C', rain: '40mm' },
      { month: 'Sep', temp: '23°C', rain: '70mm' },
      { month: 'Okt', temp: '18°C', rain: '85mm' },
      { month: 'Nov', temp: '13°C', rain: '95mm' },
      { month: 'Dez', temp: '9°C', rain: '80mm' }
    ],
    transportation: [
      { type: 'Mietwagen', cost: '€25-50/Tag', speed: 'Flexibel', comfort: 'Hoch' },
      { type: 'Bus (FlixBus)', cost: '€10-30', speed: 'Mittel', comfort: 'Mittel' },
      { type: 'Fähren', cost: '€5-25', speed: 'Langsam', comfort: 'Mittel' }
    ],
    noGos: [
      'Serbien-Kroatien-Konflikt ansprechen',
      'FKK nur in ausgewiesenen Bereichen',
      'Muscheln/Steine von Stränden mitnehmen (illegal)'
    ],
    avgCosts: {
      coffee: '€1.80',
      beer: '€2.50',
      wine: '€3.50',
      water: '€1.00',
      localFood: '€8-15',
      massage: '€35',
      manicure: '€18',
      botox: '€180-250',
      teethWhitening: '€200-350'
    },
    apps: [
      { name: 'Bolt', purpose: 'Transport', affiliate: '#' },
      { name: 'Jadrolinija', purpose: 'Fähren', affiliate: '#' }
    ],
    travelGuides: [
      { title: 'DuMont Reise Kroatien', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€22.99' }
    ],
    travel_tips: {
      highlights: ['Dubrovnik', 'Split', 'Zadar', 'Hvar', 'Korčula'],
      hidden_gems: ['Pelješac-Halbinsel', 'Kornati', 'Kleine Inseln'],
      mobility_tips: ['FlixBus günstig', 'Inselbusse statt Mietwagen'],
      eating_tips: ['Lokale Bäckereien günstig'],
      too_good_to_go: "Nicht verfügbar.",
      entry_requirements: ['Personalausweis/Reisepass'],
      international_license_needed: false,
      medication_tips: [],
      birthday_freebies: ['Split & Dubrovnik: Einige Bars bieten Rabatte']
    }
  },
  ...additionalCountries
];

export const affiliateLinks = {
  flights: [
    { name: 'Skyscanner', category: 'Flugsuche', description: 'Vergleiche Flugpreise weltweit', link: 'https://www.skyscanner.de' },
    { name: 'Momondo', category: 'Flugsuche', description: 'Finde die günstigsten Flüge', link: 'https://www.momondo.de' },
    { name: 'Kiwi.com', category: 'Flugsuche', description: 'Flexible Flugkombinationen', link: 'https://www.kiwi.com' }
  ],
  accommodation: [
    { name: 'Booking.com', category: 'Unterkunft', description: 'Hotels & Apartments weltweit', link: 'https://www.booking.com' },
    { name: 'Airbnb', category: 'Unterkunft', description: 'Einzigartige Unterkünfte', link: 'https://www.airbnb.de' },
    { name: 'Hostelworld', category: 'Unterkunft', description: 'Budget Hostels', link: 'https://www.hostelworld.com' }
  ],
  creditCards: [
    { name: 'American Express Platinum', category: 'Kreditkarte', description: 'Priority Pass, Versicherungen, Lounge-Zugang', benefits: ['Priority Pass inklusive', 'Reiseversicherung', '200+ Flughafen-Lounges', 'Statusupgrades'], link: 'https://www.americanexpress.com/de/kreditkarten/platinum-card/' },
    { name: 'Hanseatic GenialCard', category: 'Kreditkarte', description: 'Kostenlos weltweit Geld abheben', benefits: ['Keine Auslandsgebühren', 'Kostenlos Bargeld', 'Reiseversicherung'], link: 'https://www.hanseaticbank.de/kreditkarten/genialcard' }
  ],
  outdoor: [
    { name: 'Bergfreunde', category: 'Outdoor-Shop', description: 'Wander- & Trekkingausrüstung', link: 'https://www.bergfreunde.de' },
    { name: 'Decathlon', category: 'Outdoor-Shop', description: 'Sportausrüstung für alle', link: 'https://www.decathlon.de' },
    { name: 'Globetrotter', category: 'Outdoor-Shop', description: 'Reise- & Outdoor-Experten', link: 'https://www.globetrotter.de' }
  ],
  insurance: [
    { name: 'HanseMerkur', category: 'Versicherung', description: 'Reiseversicherung & Langzeit', link: 'https://www.hansemerkur.de/reiseversicherung' },
    { name: 'World Nomads', category: 'Versicherung', description: 'Abenteuer & Aktivitäten', link: 'https://www.worldnomads.com/de' }
  ],
  gear: [
    { name: 'Amazon', category: 'Reise-Gadgets', description: 'Packwürfel, Adapter, Tech', link: 'https://www.amazon.de/reise' }
  ]
};

export const lounges = [
  {
    airport: 'Frankfurt (FRA)',
    name: 'Lufthansa Business Lounge',
    terminal: 'Terminal 1, B',
    priorityPass: true,
    rating: 4.5,
    highlights: ['Duschen', 'Warme Speisen', 'Premium-Getränke', 'Ruhebereich'],
    openingHours: '5:00 - 22:00'
  },
  {
    airport: 'München (MUC)',
    name: 'Lufthansa Business Lounge',
    terminal: 'Terminal 2',
    priorityPass: true,
    rating: 4.7,
    highlights: ['Biergarten', 'Warme Küche', 'Duschen', 'Terasse'],
    openingHours: '5:00 - 22:30'
  },
  {
    airport: 'Wien (VIE)',
    name: 'Sky Lounge',
    terminal: 'Terminal 1',
    priorityPass: true,
    rating: 4.3,
    highlights: ['Wiener Spezialitäten', 'Bar', 'Zeitungen'],
    openingHours: '5:30 - 22:00'
  },
  {
    airport: 'Zürich (ZRH)',
    name: 'Aspire Lounge',
    terminal: 'Terminal 1',
    priorityPass: true,
    rating: 4.4,
    highlights: ['Swiss Chocolate', 'Warme Speisen', 'Aussicht'],
    openingHours: '6:00 - 21:30'
  },
  {
    airport: 'Bangkok (BKK)',
    name: 'Miracle First Class Lounge',
    terminal: 'Terminal 1',
    priorityPass: true,
    rating: 4.6,
    highlights: ['Spa & Massage', 'Thai Food', 'Duschen', 'Ruhezonen'],
    openingHours: '24h'
  },
  {
    airport: 'New York JFK (JFK)',
    name: 'The Centurion Lounge',
    terminal: 'Terminal 4',
    priorityPass: false,
    amexOnly: true,
    rating: 4.8,
    highlights: ['Fine Dining', 'Cocktail Bar', 'Spa', 'Duschen'],
    openingHours: '5:00 - 22:00'
  }
];

export const travelCalculatorDefaults = {
  germany: {
    avgFlightPrice: 100,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 20,
    carCosts: { fuel: 80, tolls: 15, tunnel: 0 },
    accommodation: { low: 35, mid: 80, high: 180 },
    dailyTransport: 15,
    food: 35
  },
  austria: {
    avgFlightPrice: 150,
    parking: 48,
    publicTransportToAirport: 28,
    publicTransportFromAirport: 22,
    carCosts: { fuel: 75, tolls: 20, tunnel: 12 },
    accommodation: { low: 40, mid: 85, high: 190 },
    dailyTransport: 18,
    food: 38
  },
  croatia: {
    avgFlightPrice: 120,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 12,
    carCosts: { fuel: 70, tolls: 25, tunnel: 8 },
    accommodation: { low: 30, mid: 70, high: 150 },
    dailyTransport: 12,
    food: 25
  },
  thailand: {
    avgFlightPrice: 550,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 8,
    carCosts: { fuel: 120, tolls: 30, tunnel: 0 },
    accommodation: { low: 15, mid: 35, high: 120 },
    dailyTransport: 8,
    food: 12
  },
  philippines: {
    avgFlightPrice: 650,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 5,
    carCosts: { fuel: 130, tolls: 25, tunnel: 0 },
    accommodation: { low: 12, mid: 30, high: 100 },
    dailyTransport: 6,
    food: 8
  },
  newyork: {
    avgFlightPrice: 450,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 35,
    carCosts: { fuel: 150, tolls: 40, tunnel: 15 },
    accommodation: { low: 80, mid: 180, high: 400 },
    dailyTransport: 25,
    food: 50
  },
  switzerland: {
    avgFlightPrice: 180,
    parking: 65,
    publicTransportToAirport: 30,
    publicTransportFromAirport: 25,
    carCosts: { fuel: 90, tolls: 30, tunnel: 15 },
    accommodation: { low: 60, mid: 140, high: 300 },
    dailyTransport: 25,
    food: 50
  },
  italy: {
    avgFlightPrice: 120,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 15,
    carCosts: { fuel: 75, tolls: 20, tunnel: 10 },
    accommodation: { low: 35, mid: 75, high: 180 },
    dailyTransport: 15,
    food: 30
  },
  portugal: {
    avgFlightPrice: 160,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 12,
    carCosts: { fuel: 70, tolls: 18, tunnel: 5 },
    accommodation: { low: 28, mid: 65, high: 150 },
    dailyTransport: 12,
    food: 22
  },
  poland: {
    avgFlightPrice: 110,
    parking: 38,
    publicTransportToAirport: 22,
    publicTransportFromAirport: 10,
    carCosts: { fuel: 65, tolls: 15, tunnel: 0 },
    accommodation: { low: 25, mid: 55, high: 120 },
    dailyTransport: 10,
    food: 18
  },
  dubai: {
    avgFlightPrice: 380,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 10,
    carCosts: { fuel: 140, tolls: 35, tunnel: 0 },
    accommodation: { low: 50, mid: 120, high: 300 },
    dailyTransport: 15,
    food: 35
  },
  india: {
    avgFlightPrice: 480,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 5,
    carCosts: { fuel: 150, tolls: 30, tunnel: 0 },
    accommodation: { low: 10, mid: 25, high: 80 },
    dailyTransport: 5,
    food: 8
  },
  hongkong: {
    avgFlightPrice: 580,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 12,
    carCosts: { fuel: 180, tolls: 40, tunnel: 0 },
    accommodation: { low: 60, mid: 140, high: 350 },
    dailyTransport: 18,
    food: 30
  },
  taiwan: {
    avgFlightPrice: 620,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 10,
    carCosts: { fuel: 170, tolls: 35, tunnel: 0 },
    accommodation: { low: 25, mid: 60, high: 150 },
    dailyTransport: 12,
    food: 18
  },
  austria: {
    avgFlightPrice: 90,
    parking: 42,
    publicTransportToAirport: 22,
    publicTransportFromAirport: 15,
    carCosts: { fuel: 65, tolls: 20, tunnel: 12 },
    accommodation: { low: 40, mid: 85, high: 180 },
    dailyTransport: 18,
    food: 28
  },
  liechtenstein: {
    avgFlightPrice: 200,
    parking: 65,
    publicTransportToAirport: 30,
    publicTransportFromAirport: 20,
    carCosts: { fuel: 95, tolls: 25, tunnel: 15 },
    accommodation: { low: 70, mid: 150, high: 320 },
    dailyTransport: 20,
    food: 55
  },
  hungary: {
    avgFlightPrice: 100,
    parking: 35,
    publicTransportToAirport: 20,
    publicTransportFromAirport: 8,
    carCosts: { fuel: 60, tolls: 12, tunnel: 0 },
    accommodation: { low: 22, mid: 45, high: 95 },
    dailyTransport: 8,
    food: 15
  },
  czechia: {
    avgFlightPrice: 95,
    parking: 38,
    publicTransportToAirport: 22,
    publicTransportFromAirport: 10,
    carCosts: { fuel: 62, tolls: 15, tunnel: 0 },
    accommodation: { low: 25, mid: 50, high: 110 },
    dailyTransport: 10,
    food: 18
  },
  bosnia: {
    avgFlightPrice: 140,
    parking: 35,
    publicTransportToAirport: 22,
    publicTransportFromAirport: 5,
    carCosts: { fuel: 55, tolls: 8, tunnel: 0 },
    accommodation: { low: 18, mid: 35, high: 75 },
    dailyTransport: 6,
    food: 12
  },
  tenerife: {
    avgFlightPrice: 180,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 12,
    carCosts: { fuel: 75, tolls: 0, tunnel: 0 },
    accommodation: { low: 35, mid: 70, high: 160 },
    dailyTransport: 12,
    food: 25
  },
  elhierro: {
    avgFlightPrice: 220,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 15,
    carCosts: { fuel: 80, tolls: 0, tunnel: 0 },
    accommodation: { low: 40, mid: 75, high: 150 },
    dailyTransport: 15,
    food: 28
  },
  jordan: {
    avgFlightPrice: 320,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 8,
    carCosts: { fuel: 120, tolls: 20, tunnel: 0 },
    accommodation: { low: 25, mid: 55, high: 130 },
    dailyTransport: 10,
    food: 18
  },
  oman: {
    avgFlightPrice: 350,
    parking: 45,
    publicTransportToAirport: 25,
    publicTransportFromAirport: 10,
    carCosts: { fuel: 130, tolls: 25, tunnel: 0 },
    accommodation: { low: 35, mid: 75, high: 180 },
    dailyTransport: 15,
    food: 22
  }
};

export const packingCategories = {
  basics: ['Reisepass', 'Visum (falls nötig)', 'Auslandskrankenversicherung', 'Kreditkarten', 'Bargeld', 'Handy & Ladekabel', 'Powerbank', 'Reiseadapter'],
  clothing: {
    tropical: ['Leichte T-Shirts (5x)', 'Shorts (3x)', 'Badehose/Bikini (2x)', 'Leichte Hose', 'Flip-Flops', 'Sneakers', 'Sonnenhut', 'Sonnenbrille'],
    moderate: ['T-Shirts (4x)', 'Lange Hose (2x)', 'Shorts (2x)', 'Jacke/Fleece', 'Wanderschuhe', 'Sneakers', 'Regenjacke'],
    cold: ['Thermounterwäsche', 'Fleecejacke', 'Winterjacke', 'Warme Hose', 'Mütze', 'Handschuhe', 'Schal', 'Winterschuhe']
  },
  toiletries: ['Zahnbürste & Zahnpasta', 'Shampoo', 'Duschgel', 'Deo', 'Sonnencreme', 'Medikamente', 'Erste-Hilfe-Set'],
  tech: ['Kamera', 'GoPro', 'Laptop', 'E-Reader', 'Kopfhörer', 'Alle Ladekabel'],
  activities: {
    diving: ['Tauchbrevet', 'Tauchcomputer', 'Tauchmaske (optional)'],
    hiking: ['Wanderstöcke', 'Trekkingrucksack', 'Trinkblase', 'Wanderkarte'],
    beach: ['Schnorchel-Set', 'Strandtuch', 'Wasserdichte Tasche']
  }
};

export const clothingAdvice = {
  conservative: {
    countries: ['Jordanien', 'Oman', 'Dubai', 'Indien'],
    advice: 'Schultern und Knie bedecken. Frauen: Lockere, lange Kleidung, Schal für Tempel. Männer: Lange Hosen, T-Shirt ausreichend.',
    noGos: ['Trägerlose Tops', 'Kurze Shorts', 'Durchsichtige Kleidung', 'Enge Kleidung']
  },
  moderate: {
    countries: ['Thailand', 'Philippinen', 'Kroatien', 'Portugal'],
    advice: 'In Städten & Tempeln: Schultern bedecken. An Stränden: Freizügiger OK. Zwiebelprinzip für Klimaanlagen.',
    noGos: ['Oben-ohne (außer FKK-Strände)', 'Badekleidung in Tempeln']
  },
  relaxed: {
    countries: ['Deutschland', 'Österreich', 'Schweiz', 'New York'],
    advice: 'Keine speziellen Einschränkungen. Zwiebelprinzip empfohlen für wechselhaftes Wetter.',
    noGos: []
  }
};

export const layeringSystem = {
  tropical: {
    base: 'Atmungsaktive T-Shirts aus Merino/Synthetik',
    mid: 'Leichte Langarmshirts (Sonnenschutz)',
    outer: 'Leichte Regenjacke für Monsun',
    bottom: 'Zip-off Hosen (Shorts + lange Hose)'
  },
  moderate: {
    base: 'T-Shirts + 1x Longsleeve',
    mid: 'Fleecejacke oder dünner Pulli',
    outer: 'Wasserdichte Regenjacke',
    bottom: 'Wanderhose + Shorts'
  },
  cold: {
    base: 'Thermounterwäsche (Merino)',
    mid: 'Fleecejacke + Pulli',
    outer: 'Isolierte Winterjacke',
    bottom: 'Warme Wanderhose + Thermohose'
  }
};

// Blog posts
export const blogPosts = importedBlogPosts;

